import Vue from "vue";
import Vuex from "vuex";
import ActiviteReservee from "./modules/activiteReservee";
import AutorisationDePratique from "./modules/autorisationDePratique";
import Contact from "./modules/contact";
import Catalogue from "./modules/catalogue";
import DemandeAdmission from "./modules/demandeAdmission";
import FormationInitiale from "./modules/formationInitiale";
import Langue from "./modules/langue";
import Facture from "./modules/facture";
import Lara from "./modules/lara";
import AutresAutorisationsDePratique from "./modules/autresAutorisationsDePratique";
import DeclarationsObligatoires from "./modules/declarationsObligatoires";
import AttestationVeracites from "./modules/attestationVeracite";
import TransmissionOrdre from "./modules/transmissionOrdre";
import Documents from "./modules/documents";
import CarteDAffaire from "./modules/carteDAffaire";
import Organisation from "./modules/organisation";
import DemandeInscription from "./modules/demandeInscription";
import RenseignementsGeneraux from "./modules/renseignementsGeneraux";
import StatutEmploi from "./modules/statutEmploi";
import CanadaPost from "./modules/canadaPost";
import Unitaire from "./modules/unitaire";
import Parametrage from "./modules/parametrage";
import ParamFormulaireDeprecated from "./modules/paramFormulaire";
import ParamsFormulaires from "@/components/ui/store/paramsFormulaires";
import Scolarite from "./modules/scolarite";
import Telepratique from "./modules/telepratique";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ActiviteReservee,
    AutorisationDePratique,
    Contact,
    Catalogue,
    DemandeAdmission,
    FormationInitiale,
    Langue,
    Facture,
    Lara,
    AutresAutorisationsDePratique,
    DeclarationsObligatoires,
    AttestationVeracites,
    TransmissionOrdre,
    Documents,
    CarteDAffaire,
    Organisation,
    DemandeInscription,
    RenseignementsGeneraux,
    StatutEmploi,
    CanadaPost,
    Unitaire,
    Parametrage,
    ParamFormulaireDeprecated,
    ParamsFormulaires,
    Scolarite,
    Telepratique,
  },
  action: {
    resetAllStates({ dispatch }) {
      for (const currentModule in modules) {
        if (modules[currentModule].actions.hasOwnProperty("resetModuleState")) {
          dispatch(`${currentModule}/resetModuleState`, currentModule);
        }
      }
    },
  },
});